export default __webpack_public_path__ + "static/media/icon-tel.6a02f2ee.svg";